var render = function render(){var _vm=this,_c=_vm._self._c;return _c('edit-sms',{attrs:{"channel":"rcs","test-path":"senders/rcs/test","sender":_vm.sender,"senders":_vm.senders,"raw-editing":_vm.rawEditing},on:{"saved":function($event){return _vm.$emit('saved', $event)},"done":function($event){return _vm.$emit('done')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }